import { useState, useEffect } from 'react'

export function useAuth() {
  const [state, setState] = useState({ user: null, loading: true, authenticated: false })

  useEffect(() => {
    // Dev has no /auth/me route at all (server/index.js skips auth there) —
    // main.jsx doesn't use this hook's result in dev, so skip the doomed fetch.
    if (import.meta.env.DEV) return
    fetch('/auth/me')
      .then(r => r.json())
      .then(data => setState({
        user: data.user ?? null,
        loading: false,
        authenticated: data.authenticated ?? false,
      }))
      .catch(() => setState({ user: null, loading: false, authenticated: false }))
  }, [])

  return state
}
